// extracted by mini-css-extract-plugin
module.exports = {"top":"Page1_top__1jUtc","bottom":"Page1_bottom__3vjTz"};